import { StrictMode } from 'react';
import { render } from 'react-dom';
import Rate from './components/Rate';
import ClinicAppointmentForm from './components/ClinicAppointmentForm';
import BookingForm from './components/booking/BookingForm';
import ClinicForm from './components/clinic-form/ClinicForm';
import ProfessionalForm from './components/professional-form/ProfessionalForm';
import ImageUploader from './components/ImageUploader';
import AdminAppointmentForm from './components/AdminAppointmentForm';
import ManageFeaturedClinics from './components/ManageFeaturedClinics';
import MultiImageUploader from './components/MultiImageUploader';
import ContactClinic from './components/ContactClinic';
import VideoAppointment from './components/VideoAppointment';
import SortPartnerships from './components/SortPartnerships';
import { Toaster } from 'react-hot-toast';

const components = {
    ClinicForm,
    ClinicAppointmentForm,
    AdminAppointmentForm,
    ProfessionalForm,
    BookingForm,
    Rate,
    ImageUploader,
    MultiImageUploader,
    ManageFeaturedClinics,
    ContactClinic,
    VideoAppointment,
    SortPartnerships,
    Toaster,
};

Object.keys(components).forEach((componentName) => {
    document.querySelectorAll(`[data-react="${componentName}"]`).forEach((element) => {
        const props = Object.fromEntries(
            Array.from(element.attributes)
                .filter(({ name }) => !['class', 'data-react'].includes(name))
                .map(({ name, value }) => {
                    try {
                        name = name.replace(/-./g, (x) => x[1].toUpperCase());
                        value = JSON.parse(value);
                    } catch {}
                    return [name, value];
                })
        );

        const Component = components[componentName];

        render(
            <StrictMode>
                <Component {...props} />
            </StrictMode>,
            element
        );
    });
});
